import React from 'react'
import './DemoPage.css'

export default function DemoPage() {
    return (
        <div className='demoPage-main-container'>
            {/* <img style={{ width: '100%' }} src="https://i.ibb.co/S60tF5Y/Screenshot-2022-11-13-at-5-48-21-PM.png" alt="Screenshot-2022-11-13-at-5-48-21-PM" /> */}
        </div>
    )
}
